import React, { useState } from "react";
import styles from "./styles.module.scss";

type Question = {
  id: number,
  question: string,
  answer: JSX.Element | string,
}
const QuestionsBlock = ({
  questions,
  withoutMargin,
}: {
  questions: Question[],
  withoutMargin?: boolean
}) => {
  const [openQuestionId, setOpenQuestionId] = useState(null);

  const handleQuestionClick = (id) => {
    setOpenQuestionId(openQuestionId === id ? null : id);
  };

  return (
    <section className={`${styles.Container}, ${withoutMargin && styles.ContainerWithoutPadding}`}>
      <div className="container">
        <div className={styles.QuestionsBlock}>
          {questions.map((question) => (
            <div
              key={question.id}
              className={`${styles.QuestionItem} ${openQuestionId === question.id ? styles.Open : ""
                }`}
            >
              <div
                className={styles.QuestionHeader}
                onClick={() => handleQuestionClick(question.id)}
              >
                <h3>{question.question}</h3>
                <img
                  src="/static/images/souvenir/questions-close.svg"
                  className={`${openQuestionId !== question.id ? styles.PlusIcon : styles.CloseIcon}`}
                />
              </div>
              <div className={styles.Answer}>
                <p>{question.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuestionsBlock;